import React, { HTMLAttributes } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

interface Input extends HTMLAttributes<HTMLInputElement> {
  value?: string
}

// eslint-disable-next-line react/display-name
const SearchInput = React.forwardRef<HTMLInputElement, Input>((props, ref) => {
  const { t } = useTranslation()
  return (
    <>
      <StyledSearchLabel htmlFor="search_sf" className="blind">
        {t('search_live')}
      </StyledSearchLabel>
      <StyledSearchInput ref={ref} {...props} id="search_sf" title={t('search_input')} />
    </>
  )
})

const StyledSearchInput = styled.input`
  width: 100%;
  height: 100%;
  padding: 0 5px;
  border: 0px;
  flex: 1;
  background-color: transparent;
  color: ${(props) => props.theme.font.primary};
  ::placeholder {
    color: #a8aeb3;
    font-size: 16px;
    font-weight: 700;
  }
`
const StyledSearchLabel = styled.label`
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  width: 1px;
  height: 1px;
  margin: -1px;
  line-height: normal;
  font-size: medium;
  white-space: nowrap;
`
export default SearchInput
